import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 20376 13497"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#1c1b17}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M2273 4597v-18c0-78 66-143 144-143h6271v-126H287V287h8401V153c0-78 66-144 144-144h2133c78 0 144 66 144 144v134h6707v4023h-6707v126h6994V144c0-78-65-144-143-144H144C66 0 0 66 0 144v4309c0 78 66 144 144 144h2129z"
        className="fil0"
      />
      <path
        d="M14203 4436h-3094v9c0 77-67 144-144 144H8832c-40 0-69-16-92-36-3-3-6-5-9-7-3-3-5-7-7-10-21-23-36-52-36-91v-9H2417c-78 0-144 66-144 143v4310c0 4 2 7 2 11h14317c-1-4-2-7-2-11v-143c-796-1-1591 0-2387 0-3200-1-6400 0-9599 0-682-1-1363 0-2044 0V4723h14030v-126c0-78 66-144 143-144h564c77 0 143 66 143 144v126h2649v4023c-883-1-1766 0-2649 0v143c0 4-1 7-2 11h1335c74 0 135 60 141 133h1319c39 0 68-15 91-35 3-3 7-5 10-8s4-6 6-9c21-23 36-52 36-92V4579c0-77-66-143-143-143h-6030z"
        className="fil0"
      />
      <path
        d="M18773 8900h-1335c-2 34-15 61-33 81-3 3-4 6-7 9s-6 5-10 8c-23 20-52 35-91 35h-564c-74 0-135-61-141-133H956c-77 0-143 66-143 144v4309c0 78 66 144 143 144h4336c-78 0-144-66-144-144v-143H1100V9187h4048v-44c0-78 66-144 144-144h563c78 0 143 66 143 144v44h12631v4023H5998v143c0 40-14 70-35 92-2 3-4 7-7 9-3 3-6 5-10 8-22 20-52 35-91 35h12918c39 0 69-15 91-35 3-3 7-5 10-8s4-6 6-9c22-22 36-52 36-92V9044c0-4-1-7-2-11-5-73-67-133-141-133zM2394 3773c-708 0-1290-589-1294-1294-3-706 592-1294 1294-1294 720 0 1275 589 1294 1294-19 705-574 1294-1294 1294zm563-2771c-623-240-1354-47-1779 468-916 1110 70 2809 1488 2566 762-131 1289-798 1309-1557-17-653-400-1241-1018-1477zM8975 296h1846v4005H8975V296zm-251 4240c2 3 4 7 7 10 3 2 6 4 9 7 23 20 52 36 92 36h2133c78 0 144-67 144-144V153c0-78-66-144-144-144H8832c-78 0-144 66-144 144v4292c0 39 15 68 36 91z"
        className="fil0"
      />
      <path
        d="M16877 4741h276v4005c-92-1-184 0-276 0V4741zm-144 4292h564c39 0 68-15 91-35 4-3 7-5 10-8s4-6 7-9c18-20 31-47 33-81 1-4 2-7 2-11V4597c0-78-66-144-143-144h-564c-77 0-143 66-143 144v4292c0 4 1 7 2 11 6 72 67 133 141 133zM5435 9287h276v3923h-276V9287zm521 4167c3-2 5-6 7-9 21-22 35-52 35-92V9143c0-78-65-144-143-144h-563c-78 0-144 66-144 144v4210c0 78 66 144 144 144h563c39 0 69-15 91-35 4-3 7-5 10-8z"
        className="fil0"
      />
    </g>
  </svg>
)
export default SvgComponent
